module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as0403-828d732289dcf5f9d828118f7e4495cf.jpg";